export default {
  'zh-CN': {
    uploadFiles: '上传附件',
    files: '已上传{upNum}个文件，还可以上传{remainNum}个文件',
    uploaded: '已上传{fileListLen}张，还可以上传{num}张',
    supportExtension: '支持扩展名',
    picturePreview: '图片预览',
    displayAll: '显示全部',
    loading: '加载中',
    fileTipText: '最多上传{limit}个文件，单个{maxFileSize}以内，支持格式{str}'
  },
  'en': {
    uploadFiles: 'upload files',
    files: '{UpNum} files have been uploaded, {remainNum} files can be uploaded',
    uploaded: '{FileListLen} has been uploaded, and {num} can be uploaded',
    supportExtension: 'Support extension',
    picturePreview: 'Picture Preview',
    displayAll: 'display all',
    loading: 'loading',
    fileTipText: '{limit} maximum number of files to be uploaded, within a single {maxFileSize}, support format {str}'
  }
}
